module.exports = __webpack_public_path__ + "img/loading.a6310ae3.gif";